
import VueMoney from 'v-money'

export default defineNuxtPlugin(nuxtApp => {
// Doing something with nuxtApp
    nuxtApp.vueApp.use(VueMoney)

})